import { Link } from "react-router-dom/cjs/react-router-dom";
import "./Footer.css";

export { Footer };

function Footer() {
  return (
    <>
      <div className="container-fluid footer-container">
        <p className="text-center">2022 © GeoLocation Uygulaması - <Link to="/privacypolicy">Gizlilik Politikası</Link></p>
      </div>
    </>
  );
}
